import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import AOS from "aos";
import BootstrapVue3 from "bootstrap-vue-3";
// import VueGtag from "vue-gtag";

import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import "@vueform/multiselect/themes/default.css";

import "./assets/custom.scss";
import ApiService from "./services/ApiService";
import VueViewer from "v-viewer";
import '../node_modules/viewerjs/dist/viewer.css'



const app = createApp(App).use(router);
app.use(BootstrapVue3);
ApiService.init(app);
app.use(VueViewer)
app.use(AOS.init());
// Nouveau
// app.use(VueGtag, {
//     config: { id: "GTM-TBD4NRGG" },
// }, router);


app.mount("#app");




